<template>
    <div class="mb-4">
        <pulse-loader :loading="loading"></pulse-loader>
        <div v-if="!loading && configuration">
            <div class="full-width" v-if="editable">
                <catalog-model-gallery
                    :model="configuration.model.id"
                ></catalog-model-gallery>
            </div>

            <div
                v-if="$route.query.thankyou == 1"
                class="alert alert-success mt-4"
                role="alert"
            >
                {{ $t("configuration_sent_confirm") }}
            </div>
            <div
                v-if="$route.query.thankyou == 2"
                class="alert alert-success mt-4"
                role="alert"
            >
                {{ $t("offer_request_confirm") }}
            </div>

            <div class="row">
                <div class="col-sm-12" :class="'col-md-' + (editable ? 8 : 12)">
                    <catalog-model-detail
                        :model="configuration.model"
                    ></catalog-model-detail>

                    <h2>{{ $t("standard_features") }}</h2>
                    <render-list
                        :value="configuration.model.standard_features"
                        :expandText="$t('show_all')"
                        :collapseText="$t('collapse')"
                    ></render-list>

                    <h2>{{ $t("engine_model") }}</h2>

                    <catalog-model-engine-select
                        v-if="editable"
                        @select="setEngine($event)"
                        :model="configuration.model"
                    ></catalog-model-engine-select>
                    <catalog-model-engine-list
                        v-if="!editable"
                        :engine="configuration.engine"
                    ></catalog-model-engine-list>

                    <h2>{{ $t("extra_features") }}</h2>

                    <catalog-model-options-select
                        v-if="editable"
                        @select="setOptions($event)"
                        :model="configuration.model"
                    ></catalog-model-options-select>

                    <catalog-model-options-list
                        v-if="!editable"
                        :categorizedOptions="configuration.categorizedOptions"
                        :emptyText="$t('no_options_selected')"
                    ></catalog-model-options-list>

                    <div class="card mt-3" v-if="!editable">
                        <h4 class="card-header bg-info text-white">
                            {{ $t("total") }}
                        </h4>
                        <div class="card-body standard-features">
                            <div class="row">
                                <div class="col-md-8">
                                    <p>
                                        {{ $t("base_configuration_price") }}:
                                        <currency
                                            :value="configuration.engine_price"
                                        ></currency>
                                    </p>
                                    <p>
                                        {{ $t("extra_features") }}:
                                        <currency
                                            :value="configuration.options_price"
                                        ></currency>
                                    </p>
                                    <p class="bold">
                                        {{ $t("total_price") }} ({{
                                            $t("vat_exluded")
                                        }}):
                                        <currency
                                            :value="configuration.total_price"
                                        ></currency>
                                    </p>
                                </div>
                                <div class="col-md-4">
                                    <a
                                        :href="
                                            getConfigurationPrintUrl(
                                                configuration
                                            )
                                        "
                                        target="_blank"
                                        class="btn btn-success btn-block btn-lg text-white"
                                    >
                                        <i
                                            class="fa fa-print"
                                            aria-hidden="true"
                                        ></i>
                                        {{ $t("print") }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 d-none d-md-block" v-if="configuration">
                    <price-sidebar
                        v-if="editable"
                        :configuration="configuration"
                    ></price-sidebar>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.standard-features {
    font-size: 1rem;
}
h2 {
    margin-top: 3rem;
}
.bold {
    font-weight: bold;
}
.full-width {
    height: 300px;
    margin-top: -1.5rem;
    > * {
        position: absolute;
        left: 0;
        right: 0;
    }
}
</style>

<script>
import RenderList from "./RenderList";
import ConfigurationMixin from "../mixins/Configuration";
import CatalogModelDetail from "./CatalogModelDetail";
import CatalogModelEngineList from "./CatalogModelEngineList";
import CatalogModelOptionsList from "./CatalogModelOptionsList";
import CatalogModelEngineSelect from "./CatalogModelEngineSelect";
import CatalogModelOptionsSelect from "./CatalogModelOptionsSelect";
import CatalogModelGallery from "./CatalogModelGallery";

import PriceSidebar from "./PriceSidebar";

export default {
    mixins: [ConfigurationMixin],

    inject: ["locale"],

    components: {
        CatalogModelDetail,
        CatalogModelEngineSelect,
        CatalogModelOptionsSelect,
        RenderList,
        CatalogModelOptionsList,
        CatalogModelEngineList,
        CatalogModelGallery,
        PriceSidebar,
    },

    props: {
        value: {
            type: Object,
            required: false,
        },
        editable: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    mounted: function () {
        if (!this.value) {
            this.loading = true;
            this.getConfiguration(this.$route.params.id, this.locale).then(
                (response) => {
                    this.configuration = response.data.data;
                    this.$emit("input", this.configuration);
                    this.loadTranslationsFromConfiguration(this.configuration);

                    this.loading = false;
                }
            );
        } else {
            this.configuration = this.value;
            this.loadTranslationsFromConfiguration(this.configuration);
        }
    },

    methods: {
        setEngine(engine) {
            this.configuration.engine = engine;
            this.$emit("input", this.configuration);
        },
        setOptions(options) {
            this.configuration.options = options;
            this.$emit("input", this.configuration);
        },
        loadTranslationsFromConfiguration(configuration) {
            if (!configuration.locale || configuration.locale === this.locale) {
                return;
            }

            const newQuery = {
                ...this.$route.query,
                locale: configuration.locale,
            };
            this.$router.push({ query: newQuery }).then(() => {
                window.location.reload();
            });
        },
    },

    data: function () {
        return {
            configuration: null,
            loading: false,
        };
    },
};
</script>
